export const styles = {
    appBar: {
      backgroundColor: 'white',
      boxShadow: 'none',
      borderBottom: '1px solid #e0e0e0'
    },
    toolbar: (isMobile: boolean) => ({
      justifyContent: 'space-between',
      p: isMobile ? 1 : 2
    }),
    buttonGroup: {
      backgroundColor: '#f5f5f5',
      borderRadius: '30px',
      padding: '14px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      justifyContent: 'space-between',
      width: '300px',
      gap: '20px',
      height: '43px',
      alignItems: 'center',
    },
    menuButton: (isActive: boolean) => ({
      flex: 1,
      height: '30px',
      width: '120px',
      borderRadius: '30px !important',
      padding: '10px',
      fontSize: '15px',
      backgroundColor: isActive ? '#EE2B7B' : 'transparent',
      color: isActive ? '#ffffff' : 'black',
      border: 'none',
      boxShadow: isActive ? '0px 4px 6px rgba(0, 0, 0, 0.1)' : 'none',
      transition: 'all 0.3s ease',
      textTransform: 'none',
      '&:hover': {
        color: isActive ? '#ffffff' : 'black',
        border: 'none',
        borderRadius: '30px',
        backgroundColor: isActive ? '#EE2B7B' : 'rgba(207,207,207,255)',
      },
    }),
    mobileToolbar: {
      justifyContent: 'space-between',
      pt: 0,
      borderTop: '1px solid #e0e0e0'
    },
    mobileSearchButton: {
      border: 'none',
      background: 'none',
      padding: '8px'
    },
    drawerPaper: {
      boxSizing: 'border-box',
      width: '100%',
      bgcolor: 'white'
    },
    searchIcon: {
      fontSize: '20px'
    }
  };